
import React, {Fragment, useEffect, useState} from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Virtual } from 'swiper';
import IMAGES from '../../constans/images';
type props = {
  isOpenModalBottom: Function,
  handleClose: Function
}


const ModalSelect = ({
                       isOpenModalBottom,
                       handleClose,
                       handleClick,
                        age
}:props) => {

  const [swiper, setSwiper] = React.useState(null);

  const CURRENT_YEAR = new Date().getFullYear();

  const [year,setYear] = useState(CURRENT_YEAR);

  React.useEffect(() => {
    if (swiper && age) {
      const timer = setTimeout(() => {
        swiper.slideTo(CURRENT_YEAR - age);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [age]);

  useEffect(() => {
    if (isOpenModalBottom) {
      if (document.body) {
        document.body.className = 'show-modal';
      }
    } else if (document.body) {
      document.body.className = '';
    }
  }, [isOpenModalBottom]);

  const _handleClick = () => {
    if(typeof handleClick == 'function') handleClick(year)
  }

  let html = [];
  for (let i = 0; i <= 100; i++) {
    html.push(i)
  }


  return (
    <div className={`modal-select ${isOpenModalBottom ? 'open' : ''}`}>
          <div className="modal-select--header">
            <span>년도 선택</span>
            <div
              className="modal-close"
              // role="button"
              onClick={() => handleClose()}
            >
              <img src="/images/setting/icon_close_black.svg" alt="" />
            </div>
          </div>

          <div className="modal-content modal-select-over">
            <div className="modal-over">

              <div className={'swiper-custom'}>
                <Swiper
                    direction="vertical"
                    slidesPerView="auto"
                    spaceBetween={3}
                    mousewheel
                    centeredSlides
                    // activeSlideKeyIndex={5}
                    // activeSlideKey={5}
                    // activeIndex={3}
                    onSwiper={(s) => {
                      setSwiper(s);
                    }}
                    onSlideChange={(e) => {
                      setYear(CURRENT_YEAR - e.activeIndex)
                    }}
                >
                  {html.map((item,index) => {
                    return (
                        <Fragment key={index}>
                          <SwiperSlide  key={index}>
                            {({ isActive }) => (
                                <div key={index} className={`item`}>{CURRENT_YEAR - index}</div>
                            )}
                            {/**/}
                          </SwiperSlide>
                        </Fragment>

                    )
                  })}
                </Swiper>
              </div>

              <div className={'modal-button-custom'}>
                <button
                    type={'button'}
                    className={`btn btn-block btn-primary `}
                    // disabled={isDisabled}
                    onClick={_handleClick}
                >
                  선택
                </button>
              </div>
            </div>
          </div>
        </div>
  )
}

export default ModalSelect;
